export const values = {
    maxFiles: 20,
    maxLimit: 100,
    debounceTime: 500,
    defaultSemantic: false,
    repositories: [
        'google_drive',
        'sharepoint',
        'dropbox',
        's3',
        'box'
    ],
    mediaTypes: [
        "audio",
        "video",
        "image",
        "pdf",
        "epub",
        "scorm-1.2",
        "scorm-2004",
        "xapi",
        "cmi5",
        "aicc",
        "word",
        "powerpoint",
        "html",
        "rtf",
        "vtt",
        "text",
        "markdown"
    ],
    acceptedFiles: [
        '.pdf',
        '.zip',
        '.doc',
        '.docx',
        '.ppt',
        '.pptx',
        '.html',
        '.mp4',
        '.mp3',
        '.m4a',
        '.wav',
        '.rtf',
        '.amr',
        '.flac',
        '.ogg',
        '.webm',
        '.epub',
        '.jpg',
        '.jpeg',
        '.png',
        '.gif',
        '.bmp',
        '.tif',
        '.tiff',
        '.vtt',
        '.txt',
        '.md'
    ],
    customerStatuses: [
        'Active',
        'Inactive',
        'Archived',
        'Deleted'
    ],
    customerActions: [
        'Retain',
        'Refresh',
        'Retire',
        'Reuse',
        'Review'
    ],
    authoringTools: [
        'adapt',
        'captivate',
        'dominknow',
        'ispring',
        'lectora',
        'rise',
        'storyline',
        'gomo',
        'easyg',
        'claro',
        'camtasia',
        'knowbe4',
        'percipio',
        'generic'
    ]
}